import IOrder from 'types/backend_models/orders/IOrder';
import { AppThunk } from 'redux/reducers/rootReducer';
import { setFetchOrderPending, setFetchOrderSucces, setFetchOrderError } from 'redux/reducers/data_action_reducers/orders/orderDataReducer';
import { IGenericDataFetchParams, createGenericDataFetch } from '../generic/GenericDataActions';

var fetchParams: IGenericDataFetchParams<IOrder> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchOrderPending,
	succesActionCreator: setFetchOrderSucces,
	errorActionCreator: setFetchOrderError
}

export function fetchSingleOrder(orderId: number): AppThunk
{
	fetchParams.apiEndPoint = `customer/orders/${orderId}`;
	return createGenericDataFetch<IOrder>(fetchParams);
}